import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { spring } from '../../utils/motion';
interface EqualizerProps {
  playing: boolean;
  bars?: number;
  className?: string;
  barClassName?: string;
}
const restHeights = [0.4, 0.7, 0.5, 0.85, 0.55, 0.65, 0.45];
export function Equalizer({
  playing,
  bars = 4,
  className,
  barClassName
}: EqualizerProps) {
  const reduce = useReducedMotion();
  const animated = playing && !reduce;
  return <span className={twMerge('inline-flex h-4 items-end gap-[3px]', className)} aria-hidden="true" data-id="element-786" data-mp="12mdg0atf3f3u">
      {Array.from({
      length: bars
    }).map((_, i) => <motion.span key={i} className={twMerge('h-full w-[3px] origin-bottom rounded-full bg-current', barClassName)} initial={false} animate={animated ? {
      scaleY: [0.3, 1, 0.45, 0.85, 0.3]
    } : {
      scaleY: restHeights[i % restHeights.length]
    }} transition={animated ? {
      duration: 0.8 + i % 3 * 0.17,
      repeat: Infinity,
      ease: 'easeInOut'
    } : spring.snappy} data-id="element-787" data-mp="17k59385st79m" data-mpi={i} />)}
    </span>;
}